import { Image } from '@/assets/icons'

interface OrgLogoProps {
  orgName: string
  orgLogoUrl?: string
}

/**
 * 48×48 org logo tile — shows the logo image when available, or a photo/image
 * placeholder icon centered inside a neutral tile otherwise.
 */
export function OrgLogo({ orgName, orgLogoUrl }: OrgLogoProps) {
  if (orgLogoUrl) {
    return (
      <div className="flex shrink-0 size-12 items-center justify-center overflow-hidden rounded-lg border border-brand-neutral-200 bg-white">
        <img src={orgLogoUrl} alt={orgName} className="size-full object-contain p-2" />
      </div>
    )
  }

  return (
    <div className="flex shrink-0 size-12 items-center justify-center rounded-lg border border-brand-neutral-200 bg-brand-neutral-100">
      <Image className="size-5 text-brand-neutral-400" aria-hidden />
    </div>
  )
}
